<template>
  <div>
    <van-nav-bar placeholder fixed  />
    <div class="banner-head" :style=" {backgroundImage: 'url('+ev.img+')'} ">
      <div class="title-bg">
        <div> {{ev.date}} </div>
        <div class="text-2-cut"> {{ev.title}} </div>
      </div>
    </div>
    <div class="content" v-html="ev.content"></div>
  </div>
</template>

<script>
import request from "../utils/request.js";
import Qs from "qs";
import { NavBar as VanNavBar } from 'vant'
export default {
  name: "eventsdetails",
  data() {
    return {
      msg: "赛事",
      ev: [],
      ID: 0,
      lang: 1,
    };
  },
  components: { VanNavBar },
  created() {
    this.ID = this.$route.query.event_id;
    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang;
    }
    console.log("ID:" + this.ID + " lang:" + this.lang);
    this.$axios({
      url: "/myyd/public/event_detail",
      method: "post",
      header: { "content-type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        event_id: this.ID,
        lang: this.lang,
      }),
    }).then((res) => {
      console.log("请求结果：", res.data);
      this.ev = res.data.data.event_list;
    });
  },
};
</script>

<style scoped>
.header2 * {
  box-sizing: border-box;
}
.banner-head {
  position: relative;
  width: 100vw;
  height: 240px;
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
  color: #fff;
}

.text-2-cut {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.title-bg {
  background-color: rgb(26, 24, 24, .5);
  width: 100vw;
  padding: 10px 15px;
}

.content {
  margin: 15px;
  overflow-x: hidden;
}

</style>


// WEBPACK FOOTER //
// src/components/EventsDetails.vue